import {
    put,
    takeEvery,
    select,
    all,
} from 'redux-saga/effects';
import {
    UPDATE_SEUCRITY_PROFILE_CONFIG_FAILURE,
    UPDATE_SEUCRITY_PROFILE_CONFIG_SUCCESS,
    GET_SECURITY_PROFILE_SUCCESS,
    UPDATE_AGENT_PROFILE_AND_LOG_OUT,
} from './types'
import {
    changeTheme,
    changeDirection,
    changeFont,
    changeLocale,
    changeHiddenColumns,
    changeColumnsOrder,
    changeSelectedFilters,
    changeCalendarView
} from '../configurations/actions'
import * as constants from '../../constants/index'
import { updateSecurityProfileConfig, getSecurityProfile } from './actions'
import { logoutAction } from '../authentication/actions';


var agentProfileLoading = false;

const getChannelConfigurations = (state: constants.AppState) => state.channelConfigurations
const getChannelModel = (state: constants.AppState) => state.channelModel
const getSecurityProfileState = (state: constants.AppState) => state.securityProfile
const getFont = (state: constants.AppState) => state.font
const getDirection = (state: constants.AppState) => state.direction
const getTheme = (state: constants.AppState) => state.theme
const getHiddenColumns = (state: constants.AppState) => state.hiddenColumns
const getSelectedFilters = (state: constants.AppState) => state.selectedFilters
const getColumnsOrder = (state: constants.AppState) => state.columnsOrder
const getLocale = (state: constants.AppState) => state.locale
const getCalendarView = (state: constants.AppState) => state.calendarView

function* updateAgentProfileFailed(action: any) {
    if (action.requestPayload.body.logoutRequest) {
        yield put(logoutAction(action.requestPayload.body.completeLogout));
    } else {
        yield put(getSecurityProfile())
    }
    agentProfileLoading = false
}

function* updateAgentProfileSuccess(action: any) {
    if (action.requestPayload.body.logoutRequest) {
        yield put(logoutAction(action.requestPayload.body.completeLogout));
    }
    agentProfileLoading = false
}

function* updateConfig() {
    const securityProfile = (yield select(getSecurityProfileState)) as constants.AppState
    let config;
    try {
        if (securityProfile.userProfile === null
            || securityProfile.userProfile === undefined
            || securityProfile.userProfile.config === undefined
            || securityProfile.userProfile.config === null
        ) {
            throw null;
        }
        config = JSON.parse(securityProfile.userProfile.config)
    }
    catch (err) {
        config = {}
    }

    yield all([
        put(changeTheme(config.theme !== undefined ? config.theme : constants.configuration.DEFAULT_THEME)),
        put(changeDirection(config.direction !== undefined ? config.direction : constants.configuration.DEFAULT_DIRECTION)),
        put(changeFont(config.font !== undefined ? config.font : constants.configuration.DEFAULT_FONT)),
        put(changeLocale(config.locale !== undefined ? config.locale : constants.configuration.DEFAULT_LANGUAGE)),
        put(changeHiddenColumns(config.hiddenColumns !== undefined && !Array.isArray(config.hiddenColumns) ? config.hiddenColumns : constants.configuration.DEFAULT_HIDDEN_COLUMNS)),
        put(changeColumnsOrder(config.columnsOrder !== undefined && !Array.isArray(config.columnsOrder) ? config.columnsOrder : constants.configuration.DEFAULT_COLUMNS_ORDER)),
        put(changeSelectedFilters(config.selectedFilters !== undefined && !Array.isArray(config.selectedFilters) ? config.selectedFilters : constants.configuration.DEFAULT_SELECTED_FILTERS)),
        put(changeCalendarView(config.calendarView !== undefined ? config.calendarView : constants.configuration.DEFAULT_CALENDAR_VIEW)),
    ]);
}

function* agentProfileChanged(action: any) {
    if (!agentProfileLoading) {
        const channelConfigurations = (yield select(getChannelConfigurations)) as constants.AppState
        const channelModel = (yield select(getChannelModel)) as constants.AppState
        const securityProfile = (yield select(getSecurityProfileState)) as constants.AppState
        const font = (yield select(getFont)) as constants.AppState
        const direction = (yield select(getDirection)) as constants.AppState
        const theme = (yield select(getTheme)) as constants.AppState
        const locale = (yield select(getLocale)) as constants.AppState
        const hiddenColumns = (yield select(getHiddenColumns)) as constants.AppState
        const selectedFilters = (yield select(getSelectedFilters)) as constants.AppState
        const columnsOrder = (yield select(getColumnsOrder)) as constants.AppState
        const calendarView = (yield select(getCalendarView)) as constants.AppState

        let config = {
            channelModel: channelModel,
            channelConfigurations: channelConfigurations,
            font: font,
            direction: direction,
            theme: theme,
            locale: locale,
            hiddenColumns: hiddenColumns,
            selectedFilters: selectedFilters,
            columnsOrder: columnsOrder,
            calendarView: calendarView
        }
        securityProfile.USER_CONFIG = config;
        yield put(updateSecurityProfileConfig(securityProfile.USER_CONFIG, { ...action, logoutRequest: true }))
        agentProfileLoading = true
    }
}

export default function* agentSaga() {

    // Profile => save profile
    yield takeEvery(UPDATE_AGENT_PROFILE_AND_LOG_OUT, agentProfileChanged)

    // Profile => logout after save
    yield takeEvery(UPDATE_SEUCRITY_PROFILE_CONFIG_SUCCESS, updateAgentProfileSuccess)
    yield takeEvery(UPDATE_SEUCRITY_PROFILE_CONFIG_FAILURE, updateAgentProfileFailed)

    // Profile => get profile
    yield takeEvery(GET_SECURITY_PROFILE_SUCCESS, updateConfig)
}
